import React, { useEffect, useRef, useState } from "react";
import {
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';
import utils from '../../utils/generalFunctions';
import Loading from "../../components/Loading.js";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from '@fullcalendar/core/locales/es';
import 'moment/locale/es';
import agendaService from "../../services/agendaService.js";
import AgendaForm from "../../components/Forms/AgendaForm.js";
import { Link } from "react-router-dom";
import DashboardCard from "../../components/TituloDashboard.js";
import studentPhoto from '../../img/user-profile.png';
import DocumentItem from "../../components/documentItem.js";

moment.locale('es');

const AgendaEstudiante = () => {

    const rangoActualRef = useRef({
        startDate: moment().startOf('month').format("yyyy-MM-DD"),
        endDate: moment().endOf('month').format("yyyy-MM-DD")
      });

    const [agenda, setAgenda] = useState([]);
    const [selectedEvento, setSelectedEvento] = useState(null);
    const [showLoading, setShowLoading] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [modalOpen, setModalOpen] = useState(false); // Estado para manejar la visibilidad del modal
    const colores = [
        '#3788d8', // Azul
        '#f79635', // Naranja
        '#d83738', // Rojo
        '#d83788', // Rosado
        '#38d837', // Verde
        '#8737d8'  // Morado
      ];
    const studentInfo = utils.getStudentInformation();
    const eventos = [...agenda].map((row) => {
        
        return {
            id: row.agendaId,
            title: row.title,
            description:row.description,
            start: row.startDate,
            end:row.endDate,
            journey:row.journeyName,
            year:row.schoolYearName,
            educationLevel:row.educationLevelName,
            grade:row.gradeName,
            course:row.courseName,
            student:row.studentName,
            documents:row.documents,
            backgroundColor: row.colorAleatorio, // Color del fondo
            borderColor: row.colorAleatorio,     // Color del borde
            textColor: '#ffffff'             // (opcional) Color del texto, si quieres forzar que sea legible
        };
    });

    const BuscarAgenda = async (e, hideLoading) =>{
          if(e) e.preventDefault();
          if(!hideLoading) setShowLoading(true);
          setAgenda([]);
            try {

              const data = await agendaService.getAgenda(
                studentInfo.schoolYearId, 
                studentInfo.journeyId,
                studentInfo.educationLevelId, 
                studentInfo.gradeId,
                studentInfo.courseId, 
                studentInfo.studentId, 
                rangoActualRef.current.startDate, 
                rangoActualRef.current.endDate); // Obtenemos los estudiantes de tu sistema
                
              if(data && data.length>0){
                
                const dataTransform= data.map(obj =>{
                                const colorAleatorio = colores[Math.floor(Math.random() * colores.length)];
                                obj.colorAleatorio = colorAleatorio; // Color del fondo
                                obj.borderColor= colorAleatorio;     // Color del borde
                                return obj;
                });
                setAgenda(dataTransform);
              }else{
                setAgenda([]); 
              }
            } catch (error) {
              console.error("Error al obtener horario:", error);
            }
            if(!hideLoading) setShowSearch(true);
            if(!hideLoading) setShowLoading(false);// Cambia el estado a false una vez que los datos se carguen
    }

    const handleDatesSet = (info) => {
        const startDate = info.startStr;
        const endDate = info.endStr;
    
        const start = moment(startDate).format("YYYY-MM-DD");
        const end = moment(endDate).format("YYYY-MM-DD");
    
        console.log('Calculado: ', start, end);
    
        // Aquí comparamos con el rango que tenemos guardado en el ref
        if (
          start !== rangoActualRef.current.startDate ||
          end !== rangoActualRef.current.endDate
        ) {
          console.log('Cambiando el rango de fechas...');
          
          // Actualizamos el ref SIN disparar render
          rangoActualRef.current = {
            startDate: start,
            endDate: end
          };
    
          // Y aquí llamas la función que necesites solo cuando cambien las fechas
          BuscarAgenda(null, true);
        }
    };

    const openModal = () => {
        setShowSearch(true);
        setSelectedEvento(null);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const handleEventClick = (info) => {
        info.jsEvent.preventDefault();
        const eventId = Number(info.event._def.publicId??'0');
        // Muestra un alert con el título del evento
        setSelectedEvento(eventId);
        setModalOpen(true);
      };

    useEffect(() => {
        BuscarAgenda(null);
    }, []);

        return (
            <>
             <div className="horario-estudiante-container">
                                <Link to="/dashboard" className="back-to-dashboard-pc">
                                        <FontAwesomeIcon icon={faArrowLeft} />
                                </Link> 
                                <DashboardCard
                                    studentPhoto={studentPhoto}
                                    title="Agenda escolar"
                                    subtitle=""
                                    
                                    />
            </div>          
            <div className="card p-3 margin-top-12">
                <div className="row">
                
            
                {showLoading && <Loading />}
        
                {showSearch && (
                <>
                    {!showLoading && (
                    <>
                            
                        {/* Calendario */}
                        <div className="col-lg-7">
                            <div className="card shadow-sm">
                                <div className="card-body">
                                <FullCalendar
                                    datesSet={handleDatesSet}
                                    timeZone={'local'}
                                    locales={[ esLocale ]}
                                    plugins={[dayGridPlugin, interactionPlugin]}
                                    initialView="dayGridMonth"
                                    events={eventos}
                                    eventClick={handleEventClick}
                                    locale="es"
                                    headerToolbar={{
                                    left: 'prev,next today',
                                    center: 'title',
                                    right: 'dayGridMonth,dayGridWeek',
                                    }}
                                />
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-5">
  <div className="card shadow border-0 rounded-4">
    {/* Encabezado con texto en blanco */}
    <div className="card-header bg-primary rounded-top-4 py-4">
      <h4 className="card-title mb-0 d-flex align-items-center text-white fs-3">
        <i className="bi bi-calendar-event-fill me-2 fs-2 text-white"></i>
        Agenda de la Institución
      </h4>
    </div>

    {/* Cuerpo de la card */}
    <div 
      className="card-body p-4 bg-white" 
      style={{ maxHeight: '600px', overflowY: 'auto' }}
    >
      {eventos.length > 0 ? (
        eventos.map((evento) => (
          <div 
            key={evento.id} 
            className="d-flex justify-content-between align-items-start mb-4 p-4 bg-light rounded-3 shadow-sm"
          >
            <div className="flex-grow-1 pe-3">
              {/* Título del evento */}
              <h5 className="fw-bold mb-3 text-dark fs-4">{evento.title}</h5>

              {/* Descripción */}
              <p className="text-secondary mb-3 fs-5">
                    <div dangerouslySetInnerHTML={{ __html: evento.description }} />    
              </p>

              <table className='w-auto ml-20 mt-20'>
                  {evento.documents && evento.documents.length> 0 && evento.documents?.map((doc) => (
                      <DocumentItem 
                          document={doc}
                          ReadOnly={true}
                          EnableDelete={true}
                          deleteDocument={null}
                      />
                  ))}
              </table>

              {/* Fechas */}
              <div className="text-muted mb-2 fs-5">
                📅 {moment(evento.start).format('D MMM YYYY')} - {moment(evento.end).format('D MMM YYYY')}
              </div>
            </div>
          </div>
        ))
      ) : (
        <p className="text-muted text-center fs-4 mb-0">
          No hay eventos agendados.
        </p>
      )}
    </div>
  </div>
</div>
                     
                            
                    </>
                    )}
                </>
                )}
                </div>        
            </div> 
            <MDBModal show={modalOpen} setShow={setModalOpen} tabIndex='-1'>
                <MDBModalDialog className="modal-lg">
                <MDBModalContent>
                    <MDBModalHeader>
                    <MDBModalTitle>Detalle de evento</MDBModalTitle>
                    <button className='btn-close' color='none' onClick={closeModal}></button>
                    </MDBModalHeader>
                    <MDBModalBody>
                    <div className=''>
                        {selectedEvento && (
                            <AgendaForm
                                key={Date.now()}
                                agendaId={selectedEvento}
                                onClose={() => {
                                    setModalOpen(false); 
                                    BuscarAgenda(null,true);
                                }}
                                ReadOnly={true}
                                ReadOnlyEstudent={true}
                            />
                        )}
                    </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                    <button className="btn btn-secondary" onClick={closeModal}>Cerrar</button>
                    </MDBModalFooter>
                </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>             
            </>
        );
};

export default AgendaEstudiante;
